// @ts-ignore
import YouTubePlayer from 'youtube-player';

// CAMBIAR PREFIJO DEL PROYECTO
const prefixProject: string = "trnz"

enum ModalState { Closed, Opened };

interface ReferenceElement {
    selector?: string, target?: HTMLElement | undefined;
}

interface ModalInterface {
    state: ModalState;
    refModal: ReferenceElement;
    options: ModalOptions;

    playerModal?: any;
}

interface ModalOptions {
    delegationNode?: string;
    activators?: string;
    mainClass?: string;
    onOpen?(e: MouseEvent): void;
    onClose?(e: MouseEvent, modal: Modal): void;

    iframeWrapper?: string;
    playerEvents?: {
        onReady?: (e: any) => void;
        onStateChange?: (e: any) => void;
    }
}

export default class Modal implements ModalInterface {
    initialize: boolean = false;
    state: ModalState = ModalState.Closed;
    refModal: ReferenceElement;
    options: ModalOptions = { mainClass: `${prefixProject}-modal` };

    playerModal?: any;

    constructor(modalSelector: string, options?: ModalOptions) {
        this.refModal = { selector: modalSelector, target: document.querySelector(modalSelector) as HTMLElement };
        this.options = { ...this.options, ...options };
        this.init()
    }

    init(): void {
        this.setCloseModal()
        this.setOpenModal()
    }

    loadVideoById(videoId: string): void {
        if (this.playerModal) {
            this.playerModal.loadVideoById(videoId);
            this.playVideo();
        }
    }

    playVideo(): void {
        if (this.playerModal) this.playerModal.playVideo();
    }

    stopVideo(): void {
        if (this.playerModal) this.playerModal.stopVideo();
    }

    loadYoutubeIframe(videoId: string): void {
        let { iframeWrapper, playerEvents } = this.options;
        if (iframeWrapper) {
            this.playerModal.loadVideoById(videoId)
            this.playerModal.playVideo()
            this.initialize = true;

            if (playerEvents && playerEvents.onReady) this.playerModal.on('ready', playerEvents.onReady)
            if (playerEvents && playerEvents.onStateChange) this.playerModal.on('stateChange', playerEvents.onStateChange)
        }
    }

    setOpenModal(): void {
        let { delegationNode, activators, iframeWrapper } = this.options

        if (iframeWrapper) {
            this.playerModal = YouTubePlayer(iframeWrapper, {
                playerVars: { autoplay: 1, enablejsapi: 1 },
            });
        }

        if (delegationNode) {
            document.querySelector(delegationNode)?.addEventListener('click', (e: any) => {
                if (e.target.closest(activators)) {
                    let targetElm = e.target.closest(activators);
                    this.openModal(e, targetElm);
                }
            })
            return
        }
        else if (activators) {
            let nwActivators = document.querySelectorAll(activators);
            for (let i = 0; i < nwActivators.length; i++) {
                nwActivators[i].addEventListener('click', (e) => this.openModal(e, e.currentTarget))
            }
        }

    }

    setCloseModal(): void {
        let { target } = this.refModal;
        let { mainClass } = this.options;
        let closeClasses = [`${mainClass}`, `${mainClass}__close`, `${mainClass}__close-aditional`];
        target?.addEventListener('click', (e: any) => {
            let currentTarget = e.target as HTMLElement;
            closeClasses.forEach((className: string) => {
                if (currentTarget.classList.contains(className)) this.closeModal(e)
            })
        })
    }

    openModal(e: any, target: any): void {
        let { onOpen, mainClass } = this.options
        this.state = ModalState.Opened;

        if (!this.initialize) this.loadYoutubeIframe(target.dataset.iframeYoutube);
        else this.loadVideoById(target.dataset.iframeYoutube);

        this.toggleLoader('remove')
        this.refModal.target?.classList.remove(`${mainClass}--hide`)
        if (onOpen) onOpen(e)
    }

    closeModal(e: any): void {
        let { onClose, mainClass } = this.options
        this.state = ModalState.Closed;

        this.toggleLoader('add')
        this.refModal.target?.classList.add(`${mainClass}--hide`)
        if (onClose) onClose(e, this)

        setTimeout(() => {
            if (this.playerModal) this.stopVideo()
        }, 500);
    }

    toggleLoader(state: 'add' | 'remove'): void {
        let { target } = this.refModal
        target?.querySelector(`.${prefixProject}-loader`)?.classList[state](`${prefixProject}-loader--hide`)
    }
}